import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {ProductSalesRepositoryInstance} from "../../repository/Order/ProductSalesRepository";
import {ProductSalesReportParams} from "../../shared/entities/Order/ProductSales";

export class ProductSalesService {
    constructor(_dispatch: Dispatch<PayloadAction<unknown>>) {
        // dispatch reserved for future notifications
    }

    public async report(params: ProductSalesReportParams) {
        const res = await ProductSalesRepositoryInstance.report(params);
        return res.Some;
    }
}
